import React from 'react';
import { Chart } from '@tencent/spaui';

const ChatChartInternal = (props) => (
  <div>
    <Chart {...props.echart_props} />
  </div>
);

export const ChatChart = React.memo(ChatChartInternal);
